import React from "react";
import styles from "./SuccessComponent.module.scss";
import successIcon from "../../assets/images/icons/success-icon.svg";
import CustomButton from "../ui/CustomButton/CustomButton";
import { useNavigate } from "react-router-dom";

interface SuccessComponentProps {
  title: string;
  description: string;
  linkPath?: string | null;
  linkText?: string | null;
}

const SuccessComponent: React.FC<SuccessComponentProps> = ({
  title,
  description,
  linkText,
  linkPath,
}) => {
  const navigate = useNavigate();

  const handleBackToClasses = () => {
    if (linkPath) {
      navigate(linkPath);
    }
  };

  return (
    <div className={styles.wrapper}>
      <img src={successIcon} alt={"success"} />
      <h2 dangerouslySetInnerHTML={{ __html: title }} className={styles.title}></h2>
      <p dangerouslySetInnerHTML={{ __html: description }} className={styles.description}></p>
      {linkPath && linkText && (
        <div className={styles.btnWrapper}>
          <CustomButton
            text={linkText}
            type={"button"}
            typeStyle={"fill"}
            functionOnClick={handleBackToClasses}
          />
        </div>
      )}
    </div>
  );
};

export default SuccessComponent;
